module.exports = __webpack_public_path__ + "static/headerRightBg-a890468a5921cb217e8d9b000c940b6c.png";